// extracted by mini-css-extract-plugin
export default {"image":"productsDetailHeadLeft_image__eaJr5"};